/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CallCost} from '../models/CallCost';
import type {CallCostGroup} from '../models/CallCostGroup';
import type {CallCostGroupList} from '../models/CallCostGroupList';
import type {Error} from '../models/Error';
import type {PricingModel} from '../models/PricingModel';

export interface GetCallsCosts$Request {
    accountId: number;
    pricingModel: PricingModel;
}

export interface GetCallsCosts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCallsCostsRequest = createAction<PayloadData<void, GetCallsCosts$Request>>('CALL_COST_CONTROLLER__GET_CALLS_COSTS__REQUEST');
export const getCallsCostsSuccess = createAction<PayloadData<CallCostGroupList, GetCallsCosts$Request>>('CALL_COST_CONTROLLER__GET_CALLS_COSTS__SUCCESS');
export const getCallsCostsFailure = createAction<PayloadData<Error, GetCallsCosts$Request, true>>('CALL_COST_CONTROLLER__GET_CALLS_COSTS__FAILURE');

export const getCallsCostsActions = [
    getCallsCostsRequest,
    getCallsCostsSuccess,
    getCallsCostsFailure
] as const;

/**
 * Get calls cost
 * @param {number} meta.accountId Id of account
 * @param {PricingModel} meta.pricingModel Pricing model of contract
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCallsCosts = (meta: GetCallsCosts$Request, config?: GetCallsCosts$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pricingModel: meta.pricingModel,
    };
    return {
        CALL_API: {
            types: getCallsCostsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/calls/costs`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDefaultCallsCostsForAccount$Request {
    accountId: number;
    pricingModel: PricingModel;
}

export interface GetDefaultCallsCostsForAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultCallsCostsForAccountRequest = createAction<PayloadData<void, GetDefaultCallsCostsForAccount$Request>>('CALL_COST_CONTROLLER__GET_DEFAULT_CALLS_COSTS_FOR_ACCOUNT__REQUEST');
export const getDefaultCallsCostsForAccountSuccess = createAction<PayloadData<Array<CallCost>, GetDefaultCallsCostsForAccount$Request>>('CALL_COST_CONTROLLER__GET_DEFAULT_CALLS_COSTS_FOR_ACCOUNT__SUCCESS');
export const getDefaultCallsCostsForAccountFailure = createAction<PayloadData<Error, GetDefaultCallsCostsForAccount$Request, true>>('CALL_COST_CONTROLLER__GET_DEFAULT_CALLS_COSTS_FOR_ACCOUNT__FAILURE');

export const getDefaultCallsCostsForAccountActions = [
    getDefaultCallsCostsForAccountRequest,
    getDefaultCallsCostsForAccountSuccess,
    getDefaultCallsCostsForAccountFailure
] as const;

/**
 * Get default calls costs
 * @param {number} meta.accountId Id of account
 * @param {PricingModel} meta.pricingModel Pricing model of contract
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultCallsCostsForAccount = (meta: GetDefaultCallsCostsForAccount$Request, config?: GetDefaultCallsCostsForAccount$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pricingModel: meta.pricingModel,
    };
    return {
        CALL_API: {
            types: getDefaultCallsCostsForAccountActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/calls/costs/default`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveDefaultCallsCostsForAccount$Request {
    accountId: number;
    pricingModel: PricingModel;
    callCost?: Array<CallCost>;
}

export interface SaveDefaultCallsCostsForAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveDefaultCallsCostsForAccountRequest = createAction<PayloadData<void, SaveDefaultCallsCostsForAccount$Request>>('CALL_COST_CONTROLLER__SAVE_DEFAULT_CALLS_COSTS_FOR_ACCOUNT__REQUEST');
export const saveDefaultCallsCostsForAccountSuccess = createAction<PayloadData<void, SaveDefaultCallsCostsForAccount$Request>>('CALL_COST_CONTROLLER__SAVE_DEFAULT_CALLS_COSTS_FOR_ACCOUNT__SUCCESS');
export const saveDefaultCallsCostsForAccountFailure = createAction<PayloadData<Error, SaveDefaultCallsCostsForAccount$Request, true>>('CALL_COST_CONTROLLER__SAVE_DEFAULT_CALLS_COSTS_FOR_ACCOUNT__FAILURE');

export const saveDefaultCallsCostsForAccountActions = [
    saveDefaultCallsCostsForAccountRequest,
    saveDefaultCallsCostsForAccountSuccess,
    saveDefaultCallsCostsForAccountFailure
] as const;

/**
 * Save default calls costs
 * @param {number} meta.accountId Id of account
 * @param {PricingModel} meta.pricingModel Pricing model of contract
 * @param {Array<CallCost>} [meta.callCost]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveDefaultCallsCostsForAccount = (meta: SaveDefaultCallsCostsForAccount$Request, config?: SaveDefaultCallsCostsForAccount$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pricingModel: meta.pricingModel,
    };
    return {
        CALL_API: {
            types: saveDefaultCallsCostsForAccountActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/api-v2/${meta.accountId}/calls/costs/default`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.callCost,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateCallsCosts$Request {
    accountId: number;
    pricingModel: PricingModel;
    callCostGroup?: Array<CallCostGroup>;
}

export interface UpdateCallsCosts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateCallsCostsRequest = createAction<PayloadData<void, UpdateCallsCosts$Request>>('CALL_COST_CONTROLLER__UPDATE_CALLS_COSTS__REQUEST');
export const updateCallsCostsSuccess = createAction<PayloadData<void, UpdateCallsCosts$Request>>('CALL_COST_CONTROLLER__UPDATE_CALLS_COSTS__SUCCESS');
export const updateCallsCostsFailure = createAction<PayloadData<Error, UpdateCallsCosts$Request, true>>('CALL_COST_CONTROLLER__UPDATE_CALLS_COSTS__FAILURE');

export const updateCallsCostsActions = [
    updateCallsCostsRequest,
    updateCallsCostsSuccess,
    updateCallsCostsFailure
] as const;

/**
 * Save calls cost
 * @param {number} meta.accountId Id of account
 * @param {PricingModel} meta.pricingModel Pricing model of contract
 * @param {Array<CallCostGroup>} [meta.callCostGroup]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateCallsCosts = (meta: UpdateCallsCosts$Request, config?: UpdateCallsCosts$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pricingModel: meta.pricingModel,
    };
    return {
        CALL_API: {
            types: updateCallsCostsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/api-v2/${meta.accountId}/calls/costs`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.callCostGroup,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

